import { render, staticRenderFns } from "./CardsTable.vue?vue&type=template&id=71ffb653&"
import script from "./CardsTable.vue?vue&type=script&lang=js&"
export * from "./CardsTable.vue?vue&type=script&lang=js&"
import style0 from "./CardsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VPagination,VSimpleTable})
